import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CommonUtils } from '../../utils/common.utils';
import { AseScreens, ScreenNames, User_Roles } from '../../model/common.model';
import { FieldNames } from '../../model/form-fields.model';

export const roleGuard: CanActivateFn = (route, _state) => {
  const commonUtils = inject(CommonUtils);
  const routeName = route.routeConfig?.path ?? '';
  const userInfo: any = commonUtils.userInfo;
  if (!userInfo) {
    const router = inject(Router);
    router.navigate(['home']);
    return false;
  }
  if(userInfo[FieldNames['UserAccessRoles']] === User_Roles['Super_Admin']){
    return true;
  }else if(userInfo[FieldNames['UserAccessRoles']] === User_Roles['Admin'] && routeName !== 'user_role_settings'){
    return true;
  }else if(userInfo[FieldNames['UserAccessRoles']] === User_Roles['User']){
    if(userInfo[FieldNames['UserAccessScreens']]?.includes(routeName)){
      return true
    }else if(Object.values(AseScreens).includes(routeName) && userInfo[FieldNames['UserAccessScreens']]?.includes(ScreenNames['aseLexus'])){
      return true
    }else{
      return false
    }
  }else{
    return false;
  }
};
